module.exports = __webpack_public_path__ + "img/top_banner1.1d23e7ef.png";